document.addEventListener("DOMContentLoaded", () => {
  const target = document.querySelector("button#add");
  const sticky = document.querySelector(".product__sticky-follow");
  const buttonContainer = document.querySelector(".button-container-sticky");

  if (target && sticky && buttonContainer) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            sticky.classList.add("invisible");
          } else {
            const rect = target.getBoundingClientRect();
            
            if (rect.bottom < 0) {
              sticky.classList.remove("invisible");

              buttonContainer.removeEventListener("click", handleStickyClick);
              buttonContainer.addEventListener("click", handleStickyClick);
              buttonContainer.innerHTML = target.innerHTML;
            } else {
              sticky.classList.add("invisible");
            }
          }
        });
      },
      { 
        threshold: 0,
        rootMargin: "0px 0px -100% 0px" 
      }
    );

    function handleStickyClick(e) {
      e.preventDefault();
      target.click();
    }

    observer.observe(target);
  }
});